import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PiesyncIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Piesync",
    children: isCanvas ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M19.05 17.63c0 .64-.52 1.16-1.16 1.17h-3.55c-.64 0-1.16-.53-1.16-1.17v-3.54c0-.64.52-1.16 1.16-1.17h3.55c.64 0 1.16.53 1.16 1.17z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m29.76 12.68-5.93-8.02c-.18-.31-.5-.52-.86-.55v16.44c0 1.35-1.1 2.45-2.45 2.45h-7.33v4.89h7.33c4.05 0 7.34-3.29 7.34-7.34v-6.53h1.18c.9 0 1.23-.58.72-1.34"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.03 16.6v-5.19c0-1.35 1.09-2.45 2.45-2.46h9.41V4.1h-9.41c-4.04 0-7.32 3.27-7.34 7.31v6.47H2.95c-.89 0-1.22.61-.71 1.35l5.93 8.02c.19.31.51.51.86.55z"
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.03 11.43v16.43c-.38-.04-.65-.24-.89-.55l-5.92-8.02c-.24-.38-.28-.69-.14-.97.14-.24.46-.38.89-.38h1.15v-6.51c0-2 .73-3.76 2.2-5.21C7.75 4.79 9.47 4.1 11.53 4.1h9.42v4.93h-9.42c-.69 0-1.27.24-1.72.69-.51.46-.73 1.01-.73 1.7h-.04Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m23.81 4.66 5.94 8.03c.24.38.32.69.2.93-.14.28-.46.42-.89.42h-1.21v6.51c0 2-.69 3.72-2.12 5.15s-3.21 2.2-5.21 2.2h-7.34v-4.93h7.34c.69 0 1.27-.24 1.76-.69.46-.46.69-1.03.69-1.72V4.11c.32.04.59.24.81.55h.02Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M18.96 14.08v3.58c0 .32-.08.55-.32.79s-.51.38-.85.38h-3.52c-.32 0-.61-.14-.85-.38s-.32-.46-.32-.79v-3.58c0-.32.08-.61.32-.85s.51-.32.85-.32h3.54c.32 0 .61.08.85.32.22.24.32.51.3.85"
      })]
    })
  }));
};
PiesyncIcon.displayName = 'PiesyncIcon';